export const cols = [{
	prop: 'createDate',
	label: '下单时间',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'prepareDate',
	label: '备货时间',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'wantarrivalDate',
	label: '期望到货时间',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'orderstatus',
	label: '订单状态',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'bigCategoryName',
	label: '店铺级大类',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'smallCategoryName',
	label: '店铺级小类',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'pName',
	label: '商品名称',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'pCode',
	label: '商品编号',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customerName',
	label: '客户名称',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'customerCode',
	label: '客户编号',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'customerCategoryName',
	label: '客户类别',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'matchCode',
	label: '第三方编号',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'spec',
	label: '规格',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'specCode',
	label: '规格编号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'punit',
	label: '基础单位',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'assistunit',
	label: '辅助单位',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'giftFlag',
	label: '是否赠品',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'price',
	label: '单价',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'assistquantity',
	label: '辅助数量',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'itemQuantity',
	label: '订货数量',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendCount',
	label: '实发数量',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'receiveCount',
	label: '实收数量',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'diffCount',
	label: '差发数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyDiffCount',
	label: '差收数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realReceiveCount',
	label: '净收数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundCount',
	label: '实退数量',
	width: '140',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realMoeny',
	label: '订货金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendMoney',
	label: '实发金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'reveiveMoney',
	label: '实收金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'diffMoney',
	label: '差发金额',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyDiffMoney',
	label: '差收金额',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundMoney',
	label: '实退金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realReceiveMoney',
	label: '净收金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'itemWeight',
	label: '订货重量',
	width: '160',
	ischoose: false,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendWeight',
	label: '发货重量',
	width: '160',
	ischoose: false,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'receiveWeight',
	label: '收货重量',
	width: '160',
	ischoose: false,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'liquidateMoney',
	label: '已勾销金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'ownMoney',
	label: '尚欠金额',
	width: '160',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}]
